import React, { ReactNode } from 'react';

import {
    EditableFeaturedImage,
    EditableFeaturedImageProps,
} from '@lumapps/lumx-images/components/EditableFeaturedImage';
import { Theme } from '@lumapps/lumx/react';

import { CLASSNAME } from '../../constants';

import './index.scss';

export interface EditableWidgetFeaturedImageProps extends Omit<EditableFeaturedImageProps, 'thumbnailProps'> {
    theme?: Theme;
    isEmpty?: boolean;
    isLoading: boolean;
    children?: ReactNode;
}

export const EditableWidgetFeaturedImage: React.FC<EditableWidgetFeaturedImageProps> = ({
    isEmpty,
    theme = Theme.light,
    children,
    uploadDialogOptions,
    isLoading,
    image,
    ...props
}) => {
    return (
        <EditableFeaturedImage
            {...props}
            className={CLASSNAME}
            image={isEmpty ? undefined : image}
            thumbnailProps={{ aspectRatio: 'free', isLoading }}
            imageComponent={children}
            theme={theme}
            uploadDialogOptions={uploadDialogOptions}
            scope={CLASSNAME}
        />
    );
};
